import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useEffect, useState } from "react";
import { DateTime } from "./graphql";
import { t } from "./i18n";

dayjs.extend(duration);

export const useNow = () => {
  const [now, setNow] = useState(dayjs);

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(dayjs());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return now;
};

export const formatDateTime = (date: DateTime) => {
  return dayjs(date).format("DD-MM-YYYY HH:mm:ss");
};

export const formatDurationFromNow = (date: DateTime) => {
  const from = dayjs(date);
  const today = dayjs();

  const isToday = from.isSame(today, "day");
  if (isToday) {
    const isMorning = from.hour() < 12;
    const time = from.format("HH:mm");
    return isMorning ? t("utils.date.morning_at", { time }) : t("utils.date.today_at", { time });
  }

  const isYesterday = from.isSame(today.subtract(1, "day"), "day");
  if (isYesterday) {
    const time = from.format("HH:mm");
    return t("utils.date.yesterday_at", { time });
  }

  const duration = dayjs.duration(today.diff(from));
  const days = duration.days();
  const weeks = duration.weeks();
  const months = duration.months();

  if (months > 0) {
    return t("utils.date.months_ago", { count: months });
  }

  if (weeks > 0) {
    return t("utils.date.weeks_ago", { count: weeks });
  }

  if (days > 0) {
    return t("utils.date.days_ago", { count: days });
  }

  // if the date is in the future, we just format the date
  return t("utils.date.date_at", { date: from.format("DD/MM/YYYY"), time: from.format("HH:mm") });
};
